module.exports = __webpack_public_path__ + "img/043-webpage-6.cb4c8e61.svg";